import { useState } from "react";
import { Button, Stack, Typography } from "../ds";
import ImportSuggestionsDialog from "../components/ImportSuggestionsDialog";

export default function AdminImport() {
  const [open, setOpen] = useState(false);
  return (
    <Stack spacing={2}>
      <Typography variant="h4">Historical import</Typography>
      <Typography color="text.secondary">
        Upload a workbook, match its columns, and review historical suggestions
        before importing.
      </Typography>
      <Button
        variant="contained"
        sx={{ alignSelf: "flex-start" }}
        onClick={() => setOpen(true)}
      >
        Import suggestions
      </Button>
      <ImportSuggestionsDialog open={open} onClose={() => setOpen(false)} />
    </Stack>
  );
}
